/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './queryStatuses.defs.js'
export { main as default } from './queryStatuses.defs.js'
